<dialog-draggable-header>Upload Parts for Tool#: {{tool.toolNo}}</dialog-draggable-header>

<mat-dialog-content style="overflow: hidden;">
  <mat-spinner *ngIf="uploading;else uploadMenu" class="m-auto"></mat-spinner>
  <ng-template #uploadMenu>
    <p-fileUpload name="fileUpload[]" customUpload="true" (uploadHandler)="upload($event)"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" maxFileSize="100000000">
    </p-fileUpload>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions class="mat-dialog-actions-end no-margin">
  <button mat-dialog-close mat-raised-button> Close </button>
</mat-dialog-actions>